import React, { useState, useEffect } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { IconEmailAttention, NamedLink } from '../../components';
import { getLatestListings } from './utils';
import {
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  LISTING_PAGE_DRAFT_VARIANT,
  createSlug,
} from '../../util/urlHelpers';

import css from './ModalMissingInformation.module.css';

const CompleteProfileReminder = props => {
  const { className } = props;

  const [ownListing, setOwnListing] = useState([]);

  useEffect(() => {

    getLatestListings()
      .then(resp => {
        setOwnListing(resp);
      })
      .catch(e => console.log(e));
  }, []);

  const onCompleteClick = () => {
    typeof window !== 'undefined' && 
    !!window.sessionStorage && 
    window.sessionStorage.setItem("isCompleteAccountViewed", true);
  }

  const isDraftVariant = !!ownListing?.id?.uuid && ownListing.attributes.state === LISTING_PAGE_DRAFT_VARIANT;
  const listingType = isDraftVariant
    ? LISTING_PAGE_PARAM_TYPE_DRAFT
    : LISTING_PAGE_PARAM_TYPE_EDIT;
  const listingTab = isDraftVariant ? 'photos' : 'description';
  const listingSlug = !!ownListing?.id?.uuid && createSlug(ownListing.attributes.title || '');

  return (
    <div className={className}>
      <IconEmailAttention className={css.modalIcon} />
      <p className={css.modalTitle}>
        <FormattedMessage id="ModalMissingInformation.verifyProfileTitle" />
      </p>
      <p className={css.modalMessage}>
        <FormattedMessage id="ModalMissingInformation.verifyProfileText" />
      </p>

      <div className={css.bottomWrapper} onClick={onCompleteClick}>
        {!!ownListing?.id?.uuid ? (
          <NamedLink
            name="EditListingPage"
            params={{
              id: ownListing.id.uuid,
              slug: listingSlug,
              type: listingType,
              tab: listingTab
            }}
            className={css.helperButton}
          >
            <FormattedMessage id="ModalMissingInformation.verifyProfileButton" />
          </NamedLink>
        ) : (
          <NamedLink name="NewListingPage" className={css.helperButton}>
            <FormattedMessage id="ModalMissingInformation.verifyProfileButton" />
          </NamedLink>
        )}
      </div>
    </div>
  );
};

export default CompleteProfileReminder;
